<template>
  <div id="app">
    <header>
      <nav class="navbar navbar-default">
        <div class="container">
          <div class="navbar-header">
            <div class="navbar-brand">
              <img src="@/assets/theme/logox.png">
            </div>

            <div class="main-nav">
              <ul>
                <li>ຫນ້າຫຼັກ</li>
                <li>ກ່ຽວກັບຕລຊລ</li>
                <li>ກົດໝາຍ/ລະບຽບ</li>
                <li>ສິນຄ້າແລະ ການບໍລິການ</li>
                <li>ຂໍ້ມູນຕະຫຼາດ</li>
                <li>ບໍລິສັດ/ ຂໍ້ມູນ ຫຼັກຊັບ</li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </header>
    <div class="hero-content">
      <div class="img"></div>
      <div class="container">
        <div class="block">
          <h1>ຕະຫຼາດຫຼັກຊັບລາວ</h1>
          <h2>Lao Securities Exchange</h2>
        </div>
        <LastPriceIndex />
      </div>
    </div>
    <router-view/>
    <Banners class="mb-5" />
    <ListCompany />
    <Footer />
  </div>
</template>
<script>
import LastPriceIndex from './views/components/LastPriceIndex'
import Footer from './views/components/Footer'
import ListCompany from './views/components/ListCompany'
import Banners from './views/components/Banners'

export default {
  components: {
    LastPriceIndex,
    Footer,
    ListCompany,
    Banners
  },
  created() {
    //console.log('moment', this.$moment())
  }
}
</script>
<style lang="scss">
  /* Import Font Awesome 5 Icons Set */
  $fa-font-path: '~@fortawesome/fontawesome-free/webfonts';
  @import '~@fortawesome/fontawesome-free/scss/fontawesome.scss';
  @import '~@fortawesome/fontawesome-free/scss/solid.scss';
  @import '~@fortawesome/fontawesome-free/scss/regular.scss';
  @import '~@fortawesome/fontawesome-free/scss/brands.scss';

body {
  margin: 0;
  padding: 0;
}

header {
  background-color: #004998;
  border-bottom: 1px solid #FFFFFF;

  .navbar {
    .navbar-header {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      .navbar-brand {
        color: #FFFFFF;
        padding-top: 0;
        padding-bottom: 0;

        h1 {
          margin-bottom: 0;
        }

        img {
          height: 40px;
        }
      }

      .main-nav {
        ul {
          padding-left: 0;
          margin-bottom: 0;
          display: flex;

          li {
            list-style: none;
            padding: 8px 10px;
            color: #FFFFFF;
            cursor: pointer;
          }

          li:hover {
            text-decoration: underline;
          }
        }
      }
    }
  }
}

.hero-content {
  height: 400px;
  position: relative;
  display: block;

  .img {
    display: block;
    position: absolute;
    width: 100%;
    height: 400px;
    background: url('./assets/theme/bg-laos.jpg') center bottom no-repeat #000000;
    z-index: 1;
  }

  .img::before {
    content: "";
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0,73,152,0.6);
    z-index: 2;
  }

  .block {
    z-index: 3;
    display: block;
    position: relative;
    padding-top: 70px;
    padding-bottom: 70px;
    text-align: center;
    color: #FFFFFF;

    h1 {
      font-size: 60px;
    }

    h2 {
      font-size: 45px;
    }
  }
}

@media only screen and (max-width:991px) {
  header {
    .navbar {
      .navbar-header {
        justify-content: center;

        .navbar-brand {
          margin-right: 0;
        }
        .main-nav {
          display: none;
        }
      }
    }
  }

  .hero-content {
    height: auto;
  }
}
</style>
